import { atom } from 'jotai';
import { Administrative_Area } from '@kheops/graphql';

export const administrativeAreasAtom = atom<Pick<Administrative_Area, 'area'>[]>([]);
